// ── Original posts ──
import buildingRagInProduction from './building-rag-in-production';
import observabilityIsAFeature from './observability-is-a-feature';
import kubernetesWontFixYourArchitecture from './kubernetes-wont-fix-your-architecture';
import smallDockerImages from './small-docker-images';
import aDeployPipelineYouTrust from './a-deploy-pipeline-you-trust';
import doubleEntryLedger from './double-entry-ledger';
import awsBillFinops from './aws-bill-finops';
import movingAWorkloadToGcp from './moving-a-workload-to-gcp';

// ── AI ──
import fineTuningVsRag from './fine-tuning-vs-rag';
import evaluatingLlmOutputs from './evaluating-llm-outputs';
import promptEngineeringIsApiDesign from './prompt-engineering-is-api-design';
import shippingMlModels from './shipping-ml-models';

// ── Backend ──
import idempotencyIsASuperpower from './idempotency-is-a-superpower';
import databaseIndexesThatMatter from './database-indexes-that-matter';
import designingApisYouWontHate from './designing-apis-you-wont-hate';
import cachingAndInvalidation from './caching-and-invalidation';

// ── DevOps ──
import terraformLessons from './terraform-lessons';

// ── AWS ──
import awsIamHardestEasyThing from './aws-iam-hardest-easy-thing';
import s3DatabaseCdnFootgun from './s3-database-cdn-footgun';
import ecsVsEks from './ecs-vs-eks';
import lambdaColdStart from './lambda-cold-start';

// ── GCP ──
import cloudRunFirst from './cloud-run-first';
import bigqueryAnalytics from './bigquery-analytics';
import gcpIamServiceAccounts from './gcp-iam-service-accounts';
import pubsubDecoupling from './pubsub-decoupling';

// Register every post here. Newest sorts to the top automatically.
const posts = [
  buildingRagInProduction,
  observabilityIsAFeature,
  kubernetesWontFixYourArchitecture,
  smallDockerImages,
  aDeployPipelineYouTrust,
  doubleEntryLedger,
  awsBillFinops,
  movingAWorkloadToGcp,
  fineTuningVsRag,
  evaluatingLlmOutputs,
  promptEngineeringIsApiDesign,
  shippingMlModels,
  idempotencyIsASuperpower,
  databaseIndexesThatMatter,
  designingApisYouWontHate,
  cachingAndInvalidation,
  terraformLessons,
  awsIamHardestEasyThing,
  s3DatabaseCdnFootgun,
  ecsVsEks,
  lambdaColdStart,
  cloudRunFirst,
  bigqueryAnalytics,
  gcpIamServiceAccounts,
  pubsubDecoupling,
];

// Sorted newest-first by date.
export const allPosts = [...posts].sort(
  (a, b) => new Date(b.date) - new Date(a.date)
);

export const getPostBySlug = (slug) =>
  allPosts.find((post) => post.slug === slug);

export const getPostsByCategory = (category) =>
  allPosts.filter((post) => post.category === category);

// Up to `limit` other posts, preferring the same category.
export const getRelatedPosts = (slug, limit = 3) => {
  const current = getPostBySlug(slug);
  if (!current) return allPosts.slice(0, limit);
  const others = allPosts.filter((p) => p.slug !== slug);
  const sameCat = others.filter((p) => p.category === current.category);
  const rest = others.filter((p) => p.category !== current.category);
  return [...sameCat, ...rest].slice(0, limit);
};

export default allPosts;
